module.exports = __webpack_public_path__ + "static/img/newUserAd2.f2d3527.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/img/newUserAd2.png
// module id = bjQz
// module chunks = 88